import { apiClient } from "@/lib/apiClient";
import type {
  Balancete, Balanco, Dre, Lancamento, LancamentoPartida, Paginado, ParametrizacaoContabil,
  Razao, TipoEventoContabil,
} from "../types/contabilizacao";

const BASE = "/api/contabil";

export const contabilizacaoService = {
  // ── Lançamentos ──────────────────────────────────────────────────────
  listarLancamentos: async (params: {
    dtInicio?: string; dtFim?: string; contaId?: number;
    operacaoId?: number; tipoOperacao?: number;
  }) => {
    const { data } = await apiClient.get<Lancamento[]>(`${BASE}/lancamentos`, { params });
    return data;
  },

  consultarPartidas: async (params: {
    dtInicio?: string; dtFim?: string; contaId?: number;
    tipoOperacao?: number; numero?: number;
    pagina: number; tamanhoPagina: number;
  }) => {
    const { data } = await apiClient.get<Paginado<LancamentoPartida>>(
      `${BASE}/lancamentos/consulta`, { params });
    return data;
  },

  criarLancamentoManual: async (payload: {
    empresaId: number;
    contaContabilDebitoId: number;
    contaContabilCreditoId: number;
    valor: number;
    dtMovimento: string;
    historico?: string;
  }) => {
    const { data } = await apiClient.post<{ numeroLancamento: number }>(
      `${BASE}/lancamentos`, payload);
    return data;
  },

  estornarLancamento: async (numeroLancamento: number, motivo: string) => {
    const { data } = await apiClient.post<{ lancamentosEstornados: number }>(
      `${BASE}/lancamentos/${numeroLancamento}/estornar`, { motivo });
    return data;
  },

  // ── Parametrização ──────────────────────────────────────────────────
  listarParametrizacoes: async (empresaId: number) => {
    const { data } = await apiClient.get<ParametrizacaoContabil[]>(
      `${BASE}/parametrizacoes`, { params: { empresaId } });
    return data;
  },

  salvarParametrizacao: async (payload: {
    empresaId: number;
    tipoEvento: TipoEventoContabil;
    contaContabilDebitoId: number;
    contaContabilCreditoId: number;
    descricao?: string;
    isAtivo?: boolean;
  }) => {
    const { data } = await apiClient.post<{ id: number }>(
      `${BASE}/parametrizacoes`, payload);
    return data;
  },

  removerParametrizacao: async (id: number) => {
    await apiClient.delete(`${BASE}/parametrizacoes/${id}`);
  },

  // ── Relatórios ──────────────────────────────────────────────────────
  razao: async (contaId: number, dtInicio: string, dtFim: string) => {
    const { data } = await apiClient.get<Razao>(
      `${BASE}/relatorios/razao`, { params: { contaId, dtInicio, dtFim } });
    return data;
  },

  balancete: async (empresaId: number, dtInicio: string, dtFim: string) => {
    const { data } = await apiClient.get<Balancete>(
      `${BASE}/relatorios/balancete`, { params: { empresaId, dtInicio, dtFim } });
    return data;
  },

  dre: async (empresaId: number, dtInicio: string, dtFim: string) => {
    const { data } = await apiClient.get<Dre>(
      `${BASE}/relatorios/dre`, { params: { empresaId, dtInicio, dtFim } });
    return data;
  },

  balanco: async (empresaId: number, dtPosicao: string) => {
    const { data } = await apiClient.get<Balanco>(
      `${BASE}/relatorios/balanco`, { params: { empresaId, dtPosicao } });
    return data;
  },
};
